export const PolygonTypes = {
  BORDER: "border",
  GARDEN: "garden",
  GRASS: "grass",
  PAVING: "paving",
};

export let PolygonColours = {
  [PolygonTypes.BORDER]: "#ffffff",
  [PolygonTypes.GARDEN]: "white",
  [PolygonTypes.GRASS]: "green",
  [PolygonTypes.PAVING]: "grey",
  "": "#ffffff",
};
